var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tabs',{attrs:{"v-model":_vm.customActiveKey,"tabBarStyle":{ textAlign: 'left', borderBottom: 'unset' }}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"主索引"}},[_c('empi-list')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"被合并的主索引"}},[_c('empi-list',{attrs:{"status":"2"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }